import { Talent } from '../../Classes'

const tier7 = [
  null,
  new Talent('Adrenaline Rush', 'spell_shadow_shadowworddominate', ['Increases your energy regeneration by 100% for 15 sec.'], 1, [[]], null, null, null, null, 'Instant', '5 min cooldown'),
  null,
  null,
]

export default tier7
